<script setup>
import { HandThumbUpIcon, ChatBubbleOvalLeftIcon } from '@heroicons/vue/24/outline'

defineProps({
  item: {
    type: Object,
    required: true,
  },
})

</script>
<template>
  <a :href="item.url"
     class="flex hover:bg-gray-100 transition-colors duration-150 ease-in-out rounded-lg bg-white shadow-md group gap-2"
  >
    <img
      :src="item.image"
      :alt="item.name"
      class="object-cover size-16 md:size-24 rounded-l-lg"
    >
    <div class="flex flex-col min-w-0 h-full justify-around">
      <div class="space-y-1">
        <h3
          class="text-xs capitalize sm:text-sm text-blue-600 visited:text-purple-800 lg:text-base group-hover:underline">
          {{ item.name }}
        </h3>
        <p class="truncate text-xxs sm:text-sm pr-5"> {{ item.meta_description }} </p>
      </div>
      <div class="flex flex-wrap text-xxs text-gray-600 space-x-2">
        <span v-if="item.author" class="capitalize">{{ item.author.nick }}</span>
        <span> {{ (item.published_at) ? moment(item.published_at).format('Do MMM Y') : '' }} </span>
        <div class="flex gap-0.5 items-center">
          <HandThumbUpIcon class="size-3.5 sm:size-4" />
          <span> {{ item.up_votes }}</span>
        </div>
        <div class="flex gap-0.5 sm:mr-3 items-center">
          <ChatBubbleOvalLeftIcon class="size-3.5 sm:size-4" />
          <span>{{ item.comments }}</span>
        </div>
      </div>
    </div>
  </a>
</template>
